export enum reportTypeList {
    'report' = 'Отчёт по скважине',
    'final-report' = 'Финальный отчет',
    'deviation-report' = 'Отчет ГГД отклонения',
    'well-cost' = 'Отчет стоимости скважины',
    'brigade-efficiency' = 'Отчет эффективности бригады',
    'gti-incident-report' = 'Отчет ГТИ',
    'npv-report' = 'Отчет НПВ',
    'stage-report' = 'Отчет по этапам строительства',
    'well-aggregated-report' = 'Сводный отчет',
    'well-completion-aggregated-report' = 'Сводный отчет освоения',
    'chisel-info-report' = 'Долотный отчет',
    'wells-info-report' = 'Отчет по скважинам',
    'operational-report' = 'Оперативная сводка',
    'daily-summary-report' = 'Суточный сводный отчет',
    'monitoring-log-data' = 'Выгрузка данных мониторинга',
    'monitoring-log-data-pdf' = 'Выгрузка данных мониторинга PDF',
    'measures-elements' = 'Отчет Меры Инструмента',
    'msa-correction-report' = 'Данные коррекции MSA',
    'drilling-waste-analyse-report' = 'Аналитика отходов бурения',
    'ggd-summary' = 'Детализация отклонений от ГГД',
    'bkv-report' = 'Отчет БКВ',
    'sticking-bk-question-summary' = 'Идентификатор прихвата',
    'user-login-report' = 'Отчет по входу в систему',
    'pit-report' = 'Отчет ОПИ',
    'supervising-violation-report' = 'Отчет по нарушениям',
}
